/**
 *  Copyright 2018 Avaya Inc. All Rights Reserved.
 *
 * Usage of this source is bound to the terms described in
 * licences/License.txt
 *
 * Avaya - Confidential & Proprietary. Use pursuant to your signed agreement or
 * Avaya Policy
 *
 *
 * Defines the functionality for the logon window
 */
import webChat from "./webChat"
import avayaGlobal from "./avayaGlobal"
import links from "./links"

export default {

    /**
     * The attributes for the chat. There is a known issue where Work Assignment does not accept any contact
     * whose contextId has more than 10 attributes associated with it. Those attributes include this array *AND*
     */
    attributes : ["Lang.EN"],

    // Work Assignment requires not more than 10 attributes (channel + 9 attributes) per service.
    skillSetCode: "",

    /**
     * Logs the customer into the chat.
     * @param {JSON} custDetails - JSON object that wraps up the customer details
     */
    logon : function(custDetails) {
        'use strict';
        //chatUI.changeToChatMode();
        webChat.initChat(true, custDetails);
    },

    /**
     * Gathers the customer's details before logging them in.
     */
    gatherDetails : function(custDetails, selectedSkillset, config) {
        'use strict';
        // save these details for if we need to reload the page
        links.webChatHost = config.webChatHost;
        links.coBrowseHost = config.coBrowseHost;
        links.contextStoreHost = config.contextStoreHost;

        this.attributes = selectedSkillset.attributes.split(',');
        console.log("this.attributes:",this.attributes)
        this.skillSetCode = selectedSkillset.code
        avayaGlobal.setSessionStorage("custDetails", JSON.stringify(custDetails));
        this.logon(custDetails);

    }
};
